import React from 'react'
import { SegmentsTable } from '../components/actions2/SegmentsTable'

export const Segments = () => {
    return <SegmentsTable />
}
